import Vue from 'vue';
import { HTTP_DESKDAF } from '../plugins/axios';

class OrganizationConfApi {
  /**
   * Method used to get organization configuration.
   *
   * @param {String} organizationId The organization Id.
   *
   * @returns {Promise} The result in a promise.
   */

  static all(organizationId) {
    return Vue.$http.get(`/organization/${organizationId}/conf`)
      .then(response => response.data);
  }

  static deskDafConf(organizationId) {
    return HTTP_DESKDAF.get(`/organization/${organizationId}/conf`)
      .then(response => response.data);
  }

  /**
   * Method used to update a given item.
   *
   * @param {int} id The given identifier.
   * @param {Object} item The given item.
   *
   * @returns {Promise} The result in a promise.
   */
  static update(id, item) {
    return Vue.$http.put(`/organization/${id}/conf`, item);
  }

  static updateDeskDaf(id, item) {
    return HTTP_DESKDAF.put(`/organization/${id}/conf`, item);
  }

  /**
   * Method used to create an item.
   *
   * @param {int} id The given identifier.
   * @param {Object} item The given item.
   *
   * @returns {Promise} The result in a promise.
   */
  static create(id, item) {
    return Vue.$http.post(`/organization/${id}/conf`, item);
  }

  /**
   * Method used to destroy a given item.
   *
   * @param {int} id The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  static destroy(id) {
    return Vue.$http.delete(`/organization/${id}/conf`);
  }

  /**
   * Method used to check children configuration.
   *
   * @param {int} id The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  static checkCascade(id, item) {
    return Vue.$http.post(`/organization/${id}/conf/check`, item);
  }

  static checkDeskDafCascade(id, item) {
    return HTTP_DESKDAF.post(`/organization/${id}/conf/check`, item);
  }

  /**
   * Method used to update children configuration.
   *
   * @param {int} id The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  static updateCascade(id, item) {
    console.log(item);
    return Vue.$http.post(`/organization/${id}/conf/tree`, item);
  }

  static updateDeskDafCascade(id, item) {
    return HTTP_DESKDAF.post(`/organization/${id}/conf/tree`, item);
  }

  /**
 * Method used to update domain configuration.
 *
 * @param {int} id The given identifier.
 *
 * @returns {Promise} The result in a promise.
 */
  static updateDomain(id, item) {
    console.log(item);
    return Vue.$http.post(`/organization/${id}/conf/domain`, item);
  }
}

export default OrganizationConfApi;



// WEBPACK FOOTER //
// ./src/api/OrganizationConfApi.js